import initialState from "AppCore/Store/initialState";
import Constants from "AppCore/Constants";

const { REDUCER: C } = Constants;


export default (state = initialState.shops, action) => {
	switch (action.type) {
	case C.SET_SHOPS:
		return {
			...state,
			...action.shops,
			loaded: true
		};
	case C.CLEAR_SHOPS:
		return initialState.shops;
	default:
		return state;
	}
}